import Entity from './Entity'

export default class Seating extends Entity {
  row
  seat
  section
}
